/**
 * 旧链接 /post/<cardId> 的解析。
 * 单站时代的分享地址、正文内链节点的 path 属性都是这个「路径形态」，但文章页只认 ?note-id= 查询串，
 * 不改写的话会被当成「无查询串 = 首页」直接跳走。
 */

/** 去掉 router basename（多租户前缀 /<username>），得到路由内的相对路径 */
export function stripBasename(pathname, base = '/') {
  const p = pathname || '/'
  if (!base || base === '/') return p
  if (p === base) return '/'
  return p.startsWith(base + '/') ? p.slice(base.length) : p
}

/** /post/<cardId>（可带结尾斜杠）→ cardId；其它路径返回 null */
export function cardIdFromPostPath(pathname, base = '/') {
  const m = /^\/post\/([^/]+)\/?$/.exec(stripBasename(pathname, base))
  if (!m) return null
  try {
    return decodeURIComponent(m[1]) || null
  } catch {
    return null
  }
}

/** 查询串里是否已有 note-id 参数（active-note-id 不算） */
export function hasNoteIdParam(search) {
  return /(^|[?&])note-id=/.test(search || '')
}
